export const offerStatus = [
    { value: 0, label: 'Частники/самозанятые' },
    { value: 1, label: 'Юридические лица' }
]